import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const getCheckedPermissions = (permissions, updates) => {
  return permissions.filter(permission => {
    return permission.id in updates ? updates[permission.id] : permission.isAllowed;
  });
};
const DataPermissionsContext = /*#__PURE__*/createContext(null);
export function DataPermissionsProvider({
  children,
  optionalAppPermissions,
  requiredAppPermissions,
  conditionallyRequiredAppPermissions
}) {
  const [updatedOptionalPermissions, setUpdatedOptionalPermissions] = useState({});
  const [updatedConditionallyRequiredPermissions, setUpdatedConditionallyRequiredPermissions] = useState({});
  const resetUpdatedPermissions = useCallback(() => {
    setUpdatedOptionalPermissions({});
    setUpdatedConditionallyRequiredPermissions({});
  }, []);
  const getCheckedOptionalPermissions = useCallback(() => getCheckedPermissions(optionalAppPermissions, updatedOptionalPermissions), [optionalAppPermissions, updatedOptionalPermissions]);
  const getCheckedConditionallyRequiredPermissions = useCallback(() => getCheckedPermissions(conditionallyRequiredAppPermissions, updatedConditionallyRequiredPermissions), [conditionallyRequiredAppPermissions, updatedConditionallyRequiredPermissions]);
  const updatedPermissionsCount = useMemo(() => Object.values(updatedOptionalPermissions).length + Object.values(updatedConditionallyRequiredPermissions).length, [updatedOptionalPermissions, updatedConditionallyRequiredPermissions]);
  const value = useMemo(() => ({
    updatedOptionalPermissions,
    setUpdatedOptionalPermissions,
    updatedConditionallyRequiredPermissions,
    setUpdatedConditionallyRequiredPermissions,
    updatedPermissionsCount,
    resetUpdatedPermissions,
    getCheckedOptionalPermissions,
    getCheckedConditionallyRequiredPermissions,
    optionalAppPermissions,
    requiredAppPermissions,
    conditionallyRequiredAppPermissions
  }), [updatedOptionalPermissions, updatedConditionallyRequiredPermissions, updatedPermissionsCount, resetUpdatedPermissions, getCheckedOptionalPermissions, getCheckedConditionallyRequiredPermissions, optionalAppPermissions, requiredAppPermissions, conditionallyRequiredAppPermissions]);
  return /*#__PURE__*/_jsx(DataPermissionsContext.Provider, {
    value: value,
    children: children
  });
}
export function useDataPermissions() {
  const context = useContext(DataPermissionsContext);
  if (!context) {
    throw new Error('useDataPermissions must be used within DataPermissionsProvider');
  }
  return context;
}